import React, { PropsWithChildren, Suspense, useMemo } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { esES } from '@mui/x-date-pickers/locales';

import 'dayjs/locale/es';

import { browserName } from 'react-device-detect';
import { install } from 'resize-observer';

import configureStore from 'store/configureStore';

import CatalogsProvider from 'context/catalogs';

import {
  BreadcrumbsProvider,
  NotiStackProvider,
  GlobalDndProvider,
  MuiAppTheme,
} from 'providers';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false } },
});

const spanishLocaleText =
  esES.components.MuiLocalizationProvider.defaultProps.localeText;

if (browserName === 'Safari') {
  install(); // Fix Safari ResizeObserver error
}

const AppProviders = ({ children }: PropsWithChildren) => {
  const store = useMemo(() => configureStore(), []);

  return (
    <BreadcrumbsProvider>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale="es"
        localeText={spanishLocaleText}
      >
        <NotiStackProvider>
          <GlobalDndProvider>
            <QueryClientProvider client={queryClient}>
              <Suspense fallback={<span>cargando</span>}>
                <Provider store={store}>
                  <CatalogsProvider>
                    <Router>
                      <MuiAppTheme>{children}</MuiAppTheme>
                    </Router>
                  </CatalogsProvider>
                </Provider>
              </Suspense>
            </QueryClientProvider>
          </GlobalDndProvider>
        </NotiStackProvider>
      </LocalizationProvider>
    </BreadcrumbsProvider>
  );
};

export default AppProviders;
